
import { Component, Vue, Watch } from "vue-property-decorator";
import { API_MY_PATENT_OPERATION_LIST } from "@/configs/Apis";
import DContainerLayout from "@/views/base/DContainerLayout.vue";
import DList from "@/views/base/DList.vue";
import PatentOperationView from "@/views/patentoperation/subviews/PatentOperationView.vue";
import formatters from "@/utils/ColumnFormater";
import cloneDeep from "lodash/cloneDeep";
import PatentOperatorDialog from "@/views/patent/subviews/PatentOperatorDialog.vue";
import {
  isEmpty, isNull, isEmptyOrWhiteSpace,
  showConfirm,
  showError,
  showSuccess,
  showWarning
} from "@/utils/Common";
import { MSG_001, MSG_DELETE_SUCCESS } from "@/configs/Consts";

@Component({
  components: {
    DList,
    DContainerLayout,
    PatentOperatorDialog,
    PatentOperationView
  }
})
export default class MyPatentOperationList extends Vue {
  queryStr = "";

  queryData: any = {
    operationType: "",
    operationStatus: "",
    patentNos: ""
  };

  patentOperationDetail: any = {};
  showRight = false;

  showSearch = false;

  showPatentOperator = false;
  selectedPatents: Array<any> | null = null;
  selectItem: any = {
    operationType: [],
    items: [],
    appFields: []
  };

  nodeQueryData = "";

  get searchBtnIcon(): string {
    return this.showSearch ? "el-icon-arrow-up" : "el-icon-arrow-down";
  }

  get dataApi() {
    return API_MY_PATENT_OPERATION_LIST;
  }

  openColumnConfig() {
    const grid = this.$refs.patentoperationgrid as any;
    grid.openColumnConfig();
  }

  onColumnConfiged({
    data = [],
    hidden = []
  }: { data: Array<TableColumnOption>, hidden: Array<TableColumnOption> }) {
    const newData: Array<TableColumnOption> = JSON.parse(JSON.stringify(data));
    const newHidden: Array<TableColumnOption> = JSON.parse(JSON.stringify(hidden));
    // 删除属性
    newData.forEach(item => delete item.hidden);

    if (hidden && hidden.length) {
      newData.push(...newHidden.map(val => Object.assign(val, { hidden: true })));
    }

    this.$store.dispatch("patentoperation/saveListLayout", {
      listName: "MYPATENTOPERATIONLIST",
      layout: JSON.stringify(newData)
    })
      .then(() => this.$store.dispatch("patentoperation/setColumns", []))
      .then(() => this.createTableColumns()).catch(({ message }) => showError(message));
  }

  createTableColumns() {
    const defaultColumns: Array<TableColumnOption> = [
      {
        prop: "operationType",
        display: "运营方式",
        width: 110
      },
      {
        prop: "name",
        display: "专利运营名称",
        width: 220
      },
      {
        prop: "contact",
        display: "联系人",
        width: 160
      },
      {
        prop: "phone",
        display: "联系电话",
        width: 160
      },
      {
        prop: "email",
        display: "邮箱",
        width: 160
      },
      {
        prop: "patentCount",
        display: "专利数量",
        width: 110
      },
      {
        prop: "techFields",
        display: "技术领域",
        width: 160
      },
      {
        prop: "appFields",
        display: "应用领域",
        width: 160
      },
      {
        prop: "assessedValue",
        display: "期望价格",
        width: 160
      },
      {
        prop: "operationStatus",
        display: "运营状态",
        width: 120
      },
      {
        prop: "completedContact",
        display: "完成人",
        width: 160
      },
      {
        prop: "completedEnterprise",
        display: "完成单位",
        width: 160
      },
      {
        prop: "completedDate",
        display: "完成日期",
        width: 160
      },
      // {
      //   prop: "createdUserId",
      //   display: "创建人",
      //   width: 260
      // },
      {
        prop: "remark",
        display: "备注"
      }
    ];

    this.$store.dispatch("patentoperation/getListLayout", { listName: "MYPATENTOPERATIONLIST" }).then((layout) => {
      let columns: Array<TableColumnOption>;
      if (isEmptyOrWhiteSpace(layout)) {
        columns = JSON.parse(JSON.stringify(defaultColumns));
      } else {
        columns = JSON.parse(layout);
      }
      if (columns.length === 0) {
        columns = JSON.parse(JSON.stringify(defaultColumns));
      }
      this.applyColumnFormatters(columns);
      return columns;
    }).then((columns) => this.$store.dispatch("patentoperation/setColumns", columns));
  }

  applyColumnFormatters(columns: Array<TableColumnOption>) {
    if (!columns || !columns.length) {
      return;
    }

    const fmers = {
      createdUserId: (data: any, column: any, value: any) => {
        if (isNull(data) || isNull(data.createdUser)) {
          return "";
        }
        return `${data.createdUser.name}, 单位: ${data.createdUser.enterpriseName}`;
      },
      operationStatus: formatters.formatPatentOperationStatus.bind(this)
    };

    columns.forEach(option => {
      if (!Object.prototype.hasOwnProperty.call(fmers, option.prop)) {
        return;
      }
      option.formatter = (fmers as any)[option.prop];
    });
  }

  onModuleRegistered() {
    this.$nextTick().then(() => this.createTableColumns());
  }

  onRowClick(row: any, column: any, event: MouseEvent) {
    this.showRight = true;
    if (event.stopPropagation) {
      event.stopPropagation();
    } else {
      event.cancelBubble = true;
    }
    this.patentOperationDetail = JSON.parse(JSON.stringify(row));
  }

  hideFloater() {
    this.showRight = false;
  }

  searchData() {
    if (this.queryStr.endsWith(" ")) {
      this.queryStr = this.queryStr.trim();
    } else {
      this.queryStr += " ";
    }
  }

  newPatentOperation() {
    this.selectItem = {
      id: 0,
      operationType: [],
      appFields: []
    };
    this.selectedPatents = [];
    for (let i = 0; i < 3; i++) {
      this.selectedPatents.push({
        patentType: "",
        patentNo: "",
        title: "",
        patentStatus: "",
        appDate: "",
        pubNo: "",
        pubDate: "",
        patentee: "",
        abstractInfo: "",
        remark: ""
      });
    }
    this.showPatentOperator = true;
  }

  editPatentOperation() {
    const selectedRows: Array<any> = (this.$refs
      .patentoperationgrid as any).getSelectedDataRows();
    if (!selectedRows || !selectedRows.length) {
      showWarning(MSG_001);
      return;
    }
    if (selectedRows[0].operationStatus === "COMPLETED") {
      showError("状态为：已完成，不允许修改");
      return;
    }
    this.selectItem = cloneDeep(selectedRows[0]);
    this.selectItem.operationType = this.formatMultiValues(this.selectItem.operationType);
    this.selectItem.appFields = this.formatMultiValues(this.selectItem.appFields);
    this.selectedPatents = this.selectItem.items || [];
    this.showPatentOperator = true;
  }

  formatMultiValues(str: string) {
    if (isEmptyOrWhiteSpace(str)) {
      return [];
    }
    return str.split(";");
  }

  deletePatentOperation() {
    const selectedRows: Array<any> = (this.$refs
      .patentoperationgrid as any).getSelectedDataRows();
    if (!selectedRows || !selectedRows.length) {
      showWarning(MSG_001);
      return;
    }
    const ids: Array<string> = [];
    selectedRows.forEach(row => {
      ids.push(row.id);
    });
    showConfirm("此操作将彻底删除所选信息, 是否继续?")
      .then(() => {
        this.$store
          .dispatch("patentoperation/deletePatentOperation", ids)
          .then(() => {
            this.doSearch();
            showSuccess(MSG_DELETE_SUCCESS);
          })
          .catch(({ message }) => showError(message));
      })
      .catch(() => "");
  }

  @Watch("queryData.operationType")
  @Watch("queryData.operationStatus")
  onQueryChanged() {
    const params: { [key: string]: any } = {};
    if (!isEmpty(this.nodeQueryData)) {
      const nodeFilter = JSON.parse(this.nodeQueryData);
      Object.keys(nodeFilter).forEach(
        name => (params[name] = nodeFilter[name])
      );
    }

    if (!isEmpty(this.queryData.operationType)) {
      params.operationType = this.queryData.operationType;
    }

    if (!isEmpty(this.queryData.operationStatus)) {
      params.operationStatus = this.queryData.operationStatus;
    }

    if (!isEmpty(this.queryData.patentNos)) {
      params.patentNos = this.queryData.patentNos;
    }

    const paramsStr = JSON.stringify(params);
    if (paramsStr === "{}" && this.queryStr.trim() === "") {
      return;
    }
    if (paramsStr !== this.queryStr.trim()) {
      this.queryStr = JSON.stringify(params);
    }
  }

  doSearch() {
    this.queryStr += " ";
  }
}
